import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Table from 'components/new_ui/Table';
import Modal from 'components/new_ui/Modal/Modal';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext } from 'components/Managers/Members/Context';

import columns from './columns';
import Statistics from './Statistics';

export default function Summary({ show, members, cancelCallback }) {
  const { state: stateTeams } = useTeamsContext();
  const { state, dispatch, actions } = useContext();
  const navigate = useNavigate();

  const newMembers = members.filter((member) => member.status === 'New');

  const formSchema = Yup.object().shape({
    team: Yup.string().when('team', () => {
      if (newMembers.length > 0) {
        return Yup.string().typeError('Please, choose a team.');
      }
      return Yup.string().nullable().optional();
    }),
  }, [['team', 'team']]);

  const onSubmitHundler = (values, { setSubmitting, _setErrors }) => {
    const params = {
      members: members.map((member) => ({ ...member, team: values.team })),
      team: values.team,
      only_validate: false,
      file_name: state.fileName,
    };

    actions.fileImport(
      dispatch,
      state.enterpriseId,
      params,
      (_data) => {
        setSubmitting(false);
        navigate(routes.managers.members.success, { state: { members } });
      },
    );
  };

  return (
    <Modal show={show} size="lg">
      <h4 className="mb-4">Members to import</h4>

      <Formik
        validationSchema={formSchema}
        initialValues={{
          team: null,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <section>
              {newMembers.length > 0 && (
                <>
                  <p>
                    Please, select a team for your members.
                  </p>

                  <Row>
                    <Col md="6">
                      <HorizontalSelectField
                        name="team"
                        label=""
                        options={
                        (stateTeams.teams || []).map((team) => ({
                          label: team.attributes.title,
                          value: team.id,
                        }))
                      }
                        isLoading={stateTeams.teams === null}
                        required={newMembers.length > 0}
                      />
                    </Col>
                  </Row>
                </>
              )}

              <Statistics
                newMembersCount={newMembers.length}
                totalMembersCount={members.length}
              />

              <Table
                columns={columns}
                data={members}
                selectableRows={false}
              />
            </section>

            <footer>
              <Button
                variant="outline-primary"
                onClick={() => cancelCallback()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting || members.length === 0 || (newMembers.length > 0 && stateTeams.teams === null)}
              >
                {isSubmitting && <LoadingPlaceholder placement="inline" text=" " />}
                Import
              </Button>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Summary.propTypes = {
  show: PropTypes.bool.isRequired,
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  cancelCallback: PropTypes.func.isRequired,
};
